/* 🤖 this file was generated by svg-to-ts */
export const waytrNotification = {
    name: 'notification',
    data: `<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.1 48.1"><path d="M41.54,30.61c1.93,0,3.5,1.57,3.5,3.5s-1.57,3.5-3.51,3.5H6.57c-1.94,0-3.51-1.57-3.51-3.5s1.57-3.5,3.5-3.5c.96,0,1.75-.78,1.75-1.75v-10.49c0-8.7,7.05-15.74,15.74-15.74s15.74,7.05,15.74,15.74v10.49c0,.97,.78,1.75,1.75,1.75Zm-23.61,8.75h12.24c0,3.38-2.74,6.12-6.12,6.12s-6.12-2.74-6.12-6.12Z"/></svg>`,
};
